module.exports = __webpack_public_path__ + "static/media/exclamation-mark-white.99969460.svg";